import React from "react";
import { Table, TableBody, TableHeader, TableRow, TableRowColumn } from "material-ui";
import { FormattedMessage, injectIntl } from "react-intl";
import images from "../../config/images";
import moment from "moment";

export const tdStyle = {
  borderRight: "1px solid #b8b8b8",
  textAlign: "center",
  whiteSpace: "pre-wrap",
  overflow: "hidden",
  padding: "5px 10px",
  color: "#6B7c93",
};

class QuestionnaireTable extends React.Component {  

  formatRegisteredDate = (date) => {
    return date ? moment(new Date(date)).format('YYYY/MM/DD HH:mm') : '-';
  }

  render() {

    return (
      <div className="table-wrapper" style={{ marginTop: "10px" }}>
        <Table
          selectable={false}
          fixedHeader={true}
          height="70vh"
          selectedColor="black"
          className="table-container"
          style={{ border: "1px solid #b8b8b8", minWidth: "612px" }}
        >
          <TableHeader displaySelectAll={false} enableSelectAll={false} adjustForCheckbox={false}>
            <TableRow
                style={{
                  border: "1px solid #b8b8b8",
                  backgroundColor: "#6B7c93",
                  color: "#fff",
                }}
              >
                <TableRowColumn colSpan={2} style={{ ...tdStyle, color: "#fff" }}>
                  {<FormattedMessage id="questionnaire.registerAt" />}
                </TableRowColumn>
                <TableRowColumn colSpan={2} style={{ ...tdStyle, color: "#fff" }}>
                  {<FormattedMessage id="questionnaire.title" />}
                </TableRowColumn>
                <TableRowColumn colSpan={3} style={{ ...tdStyle, color: "#fff" }}>
                  {<FormattedMessage id="questionnaire.question" />}
                </TableRowColumn>
                <TableRowColumn style={{ ...tdStyle, color: "#fff" }}>
                  {<FormattedMessage id="roomList.roomName" />}
                </TableRowColumn>
                <TableRowColumn style={{ ...tdStyle, color: "#fff" }}>
                  {<FormattedMessage id="roomList.edit" />}
                </TableRowColumn>
              </TableRow>
          </TableHeader>
          <TableBody  deselectOnClickaway={false} displayRowCheckbox={false}>

            {this.props.isFetching ||
              (this.props.questionnaires.length === 0 && (
                <TableRow
                  selected={false}
                  className="light-row"
                  style={{
                    backgroundColor: "#f2f3f6",
                    borderBottom: "1px solid #b8b8b8",
                  }}
                >
                  <TableRowColumn colSpan={9} style={tdStyle}>
                    {this.props.isFetching
                      ? <FormattedMessage id="questionnaire.fetchingQuestionnaire" />
                      : <FormattedMessage id="questionnaire.noQuestionnaireFound" />}
                  </TableRowColumn>
                </TableRow>
              ))}

            {this.props.questionnaires.map((questionnaire, index) => {
              return (
                <TableRow
                  key={index}
                  selected={false}
                  className={index % 2 == 0 ? "dark-row" : "light-row"}
                  style={{
                    backgroundColor: "#f2f3f6",
                    borderBottom: "1px solid #b8b8b8",
                  }}
                >
                  <TableRowColumn colSpan={2} style={tdStyle}>
                    {this.formatRegisteredDate(questionnaire.registered_at)}
                  </TableRowColumn>
                  <TableRowColumn colSpan={2} style={{...tdStyle, textAlign: 'left'}}>
                    {questionnaire.title}
                  </TableRowColumn>
                  <TableRowColumn colSpan={3} style={{...tdStyle, textAlign: 'left'}}>
                    {questionnaire.question}
                  </TableRowColumn>
                  <TableRowColumn style={tdStyle}>
                    {this.props.isRoomFetched 
                      ? this.props.rooms && this.props.rooms.find(r => r.id === questionnaire.room_id) ? questionnaire.room_name 
                      : <FormattedMessage id="questionnaire.deleted" /> : ''}
                  </TableRowColumn>
                  <TableRowColumn style={tdStyle}>
                    <img
                      src={images.editIcon}
                      style={{ width: "24px", cursor: "pointer" }}
                      onClick={() => {
                        this.props.editQuestionnaire(questionnaire);
                      }}
                    />
                  </TableRowColumn>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default injectIntl(QuestionnaireTable);



// WEBPACK FOOTER //
// src/components/Questionnaire/QuestionnaireTable.js